// extracted by mini-css-extract-plugin
module.exports = {"width":"DoubleOffer_width__GHOOR","offerLink":"DoubleOffer_offerLink__1IUlM"};